export default __webpack_public_path__ + "static/media/crc-logo.d3d6af7f.png";